<script setup lang="ts">
import { ref, watch } from 'vue';
import { Icon } from '@iconify/vue';
import { useCustomizerStore } from '@/stores/customizer';
import LanguageDD from './LanguageDD.vue';
import NotificationDD from './NotificationDD.vue';
import ProfileDD from './ProfileDD.vue';
import Searchbar from './Searchbar.vue';
import RightMobileSidebar from './RightMobileSidebar.vue';
import Navigations from './Navigations.vue';
import ThemeToggler from './ThemeToggler.vue';
import SidebarLogo from '@/components/sidebar/logo/Logo.vue';

const customizer = useCustomizerStore();
const priority = ref(0);

watch(priority, (next) => {
  priority.value = next;
});

function toggleSidebar() {
  customizer.SET_SIDEBAR_DRAWER();
}
</script>

<template>
  <v-app-bar
    id="top"
    elevation="0"
    :priority="priority"
    height="70"
    class="main-head"
  >
    <v-btn
      class="hidden-lg-and-up custom-hover-primary"
      size="small"
      variant="text"
      color="primary"
      icon
      @click.stop="toggleSidebar()"
    >
      <Icon
        icon="solar:hamburger-menu-line-duotone"
        height="22"
      />
    </v-btn>

    <!-- Desktop: collapse the sidebar to an icon rail (the rail used to carry
         this toggle before the sidebar became a single full-menu panel) -->
    <v-btn
      class="hidden-md-and-down custom-hover-primary"
      size="small"
      variant="text"
      color="primary"
      icon
      @click.stop="customizer.SET_MINI_SIDEBAR(!customizer.mini_sidebar)"
    >
      <Icon
        icon="solar:hamburger-menu-line-duotone"
        height="22"
      />
    </v-btn>

    <Searchbar />

    <div class="hidden-sm-and-down">
      <Navigations />
    </div>

    <v-spacer class="hidden-sm-and-down" />

    <div class="hidden-md-and-up">
      <SidebarLogo />
    </div>

    <ThemeToggler />

    <div class="hidden-sm-and-down">
      <LanguageDD />
    </div>

    <div class="hidden-sm-and-down">
      <NotificationDD />
    </div>

    <div class="hidden-sm-and-down">
      <ProfileDD />
    </div>

    <v-menu
      :close-on-content-click="true"
      class="mobile_popup"
    >
      <template #activator="{ props }">
        <v-btn
          icon
          class="hidden-md-and-up custom-hover-primary"
          color="primary"
          variant="text"
          v-bind="props"
          size="small"
        >
          <Icon
            icon="solar:menu-dots-bold-duotone"
            height="22"
          />
        </v-btn>
      </template>
      <v-sheet
        rounded="lg"
        elevation="10"
        class="mt-4 dropdown-box px-4 py-3"
      >
        <div class="d-flex justify-space-between align-center">
          <RightMobileSidebar />
          <LanguageDD />
          <NotificationDD />
          <ProfileDD />
        </div>
      </v-sheet>
    </v-menu>
  </v-app-bar>
</template>

<style lang="scss" scoped>
.main-head {
  border-bottom: 1px solid rgb(var(--v-theme-borderColor));
}

.custom-hover-primary {
  &:hover {
    background-color: rgb(var(--v-theme-lightprimary));
    color: rgb(var(--v-theme-primary));
  }
}

.dropdown-box {
  min-width: 300px;
}
</style>
